// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"a920aef5","209":"8a7ab032","288":"5fb037a8","488":"e23434cb","862":"b51a9d6f","994":"eae04900"}[chunkId] + ".chunk.js";
};